import { Badge } from "antd";
import { GENDER_TYPE } from "../../domain/notes.domain";

type Props = {
  gender_type?: number | null | undefined;
  isBadge?: boolean;
};

export default function GenderType({ gender_type, isBadge = true }: Props) {
  const style = { color: "#747474" };
  if (gender_type === GENDER_TYPE.NEUTRAL)
    return isBadge ? <Badge count={"Neutral"} showZero className="badge-soap" /> : <span style={style}>(Neutral)</span>;
  if (gender_type === GENDER_TYPE.MALE)
    return isBadge ? <Badge count={"He/Him"} showZero className="badge-soap" /> : <span style={style}>(He/Him)</span>;
  else
    return isBadge ? <Badge count={"She/Her"} showZero className="badge-soap" /> : <span style={style}>(She/Her)</span>;
}
